<template>
  <div class="container-fluid py-4">
    <h2 class="page-heading">Интеграция с Vendaxis API</h2>
    <p class="text-muted">Параметры исходящей отправки обработанных команд Vendoscope во внешний API.</p>

    <form class="mt-4" @submit.prevent="save">
      <div class="form-group form-check">
        <input id="external-api-enabled" v-model="form.enabled" type="checkbox" class="form-check-input">
        <label class="form-check-label" for="external-api-enabled">Отправлять команды в Vendaxis</label>
      </div>
      <div class="form-group">
        <label for="external-api-endpoint">Адрес API</label>
        <input id="external-api-endpoint" v-model="form.endpoint" type="url" class="form-control" required>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="external-api-key">API-ключ</label>
          <input id="external-api-key" v-model="form.api_key" type="password" class="form-control" autocomplete="new-password" :placeholder="secretPlaceholder(form.has_api_key)">
          <small class="form-text text-muted">Оставьте пустым, чтобы сохранить текущий ключ.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="external-api-hmac">HMAC-секрет</label>
          <input id="external-api-hmac" v-model="form.hmac_secret" type="password" class="form-control" autocomplete="new-password" :placeholder="secretPlaceholder(form.has_hmac_secret)">
          <small class="form-text text-muted">Секрет хранится зашифрованным и повторно не показывается.</small>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="external-api-timeout">Тайм-аут, секунд</label>
          <input id="external-api-timeout" v-model.number="form.timeout" type="number" min="1" max="120" class="form-control" required>
        </div>
        <div class="form-group col-md-6">
          <label for="external-api-queue">Очередь</label>
          <input id="external-api-queue" v-model="form.queue" type="text" class="form-control" pattern="[A-Za-z0-9._-]+" required>
        </div>
      </div>
      <button class="btn btn-primary" type="submit" :disabled="saving">{{ saving ? 'Сохранение…' : 'Сохранить' }}</button>
      <span v-if="saved" class="ml-3 text-success">Настройки сохранены.</span>
    </form>
  </div>
</template>

<script>
import api from '@/api'

export default {
  metaInfo: {title: 'Настройки внешних API'},
  data: () => ({
    form: {
      enabled: false,
      endpoint: '',
      api_key: '',
      hmac_secret: '',
      timeout: 30,
      queue: 'vendaxis',
      has_api_key: false,
      has_hmac_secret: false,
    },
    saving: false,
    saved: false,
  }),
  created () {
    api.get('billing/settings/external-api').then(({data}) => {
      this.form = Object.assign(this.form, data)
    })
  },
  methods: {
    secretPlaceholder (configured) {
      return configured ? 'Настроено' : 'Не настроено'
    },
    save () {
      this.saving = true
      this.saved = false
      return api.put('billing/settings/external-api', this.form)
        .then(({data}) => {
          this.form = Object.assign(this.form, data, {api_key: '', hmac_secret: ''})
          this.saved = true
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/settings/external-api.vue